const config = require("../config")

module.exports = {
    // 录入用户权属信息
    addPlotInfo: {
        url: config.base_new_url + "questionnaire/add_plot_info",
        type: "post",
    },
    // 获取初始互动接口
    getInitialInteraction: {
        url: config.base_new_url + "pheno/initial_interact_options",
        type: "get",
    },
    // 保存感知结果接口
    saveInteractResult: {
        url: config.base_new_url + "pheno/interact_record",
        type: "post",
    },
    // 初始化报告
    generateReport: {
        url: config.base_new_url + "report/generate",
        type: "get",
    },
    // 查看报告是否生成
    checkReportGenerated: {
        url: config.base_new_url + "report/check",
        type: "get",
    },
    // 区县作物物候期（种植品类下拉）
    countyPhenophase: {
        url: config.base_new_url + "report/county_phenophase",
        type: "get",
    },
    // 用户农事列表
    userWork: {
        url: config.base_new_url + "report/user_work",
        type: "get",
    },
    // 修改农事状态（完成）
    updateWorkStatus: {
        url: config.base_new_url + "report/update_work_status",
        type: "post",
    },
    // 物候期问题查询
    phenologyProblem: {
        url: config.base_new_url + "report/crop_question",
        type: "get",
    },
    // 巡园互动解析（长势跟踪要点）
    parseInteract: {
        url: config.base_new_url + "report/parse_interact",
        type: "get",
    },
    // 异常内容查询
    abnormalContent: {
        url: config.base_new_url + "report/parse_anormal",
        type: "get",
    },
    // 物候调整确认
    adjustPhenology: {
        url: config.base_new_url + "report/adjust_phenophase",
        type: "get",
    },
    // 是否需要弹窗诊断报告
    getReportStatus: {
        url: config.base_new_url + "report/get_popup_status",
        type: "get",
    },
    // 修改诊断报告弹窗状态
    setReportStatus: {
        url: config.base_new_url + "report/set_popup_closed",
        type: "post",
    },
    // 查询物候期
    getPhenology: {
        url: config.base_new_url + "report/get_phenophase",
        type: "get",
    },
    // 作物档案：物候期信息列表
    getPhenophaseInfo: {
        url: config.base_new_url + "report/get_phenophase_info",
        type: "get",
    },
    // 气象风险报告
    riskReport: {
        url: config.base_new_url + "report/risk_report",
        type: "get",
    },
    // 胁迫报告
    stressReport: {
        url: config.base_new_url + "report/stress_report",
        type: "get",
    },
    // 异常农情研判报告列表
    queryAbnormalReport: {
        url: config.base_new_url + "report/query_abnormal_report",
        type: "get",
    },
    // 气象报告列表
    weatherReportList: {
        url: config.base_new_url + "report/weather_report_list",
        type: "get",
    },
    // 异常巡检拍照提交
    inspect: {
        url: config.base_new_url + "report/inspect",
        type: "post",
    },
    // 农情相册临时照片
    queryTmpImage: {
        url: config.base_new_url + "report/query_tmp_image",
        type: "get",
    },
    // 查询气象报告是否生成
    checkWeatherReportGenerated: {
        url: config.base_new_url + "report/check_stress_report",
        type: "get",
    },
}